import React from "react";
import { connect } from "react-redux";
import { Button, Glyphicon } from "react-bootstrap";
import AddConfigurationElementModal from "./add-configuration-element-modal";
import MatchListModal from "./matchlist-modal";
import { Tag, DataType, Column, Types } from "./constant";

class ConfigurationElement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMatchlistModal: false,
      configuration: props.configuration,
      showAddElementModal: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.closeAddElementModal = this.closeAddElementModal.bind(this);
    this.closeMatchlistModal = this.closeMatchlistModal.bind(this);
    this.onAddField = this.onAddField.bind(this);
    this.onMatchListRowClick = this.onMatchListRowClick.bind(this);
  }

  handleChange(event, column) {
    this.props.onHandleChange(event, column, this.state.configuration.dataType);
  }

  closeAddElementModal() {
    this.setState({ showAddElementModal: false });
  }

  onAddField(field) {
    this.props.onAdd(field);
    this.closeAddElementModal();
  }

  onRemove(id, path) {
    this.props.onRemove(id, path);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      configuration: nextProps.configuration,
    });
  }

  closeMatchlistModal() {
    this.setState({ showMatchlistModal: false });
  }

  onMatchListRowClick(item) {
    this.props.onMatchListRowClick(this.state.configuration.id, item);
    this.closeMatchlistModal();
  }

  getTypeValue = (displayValue) => {
    let val = "";
    Types.forEach((type) => {
      if (type.name === displayValue) {
        val = `${type.id}`;
      }
    });
    return val;
  };

  render() {
    const {
      id,
      fieldName,
      value,
      displayValue,
      tag,
      dataType,
      sequence,
      path,
      includeInRecipe,
    } = this.state.configuration;

    let tagsValues = [];

    if (dataType === DataType.Boolean) {
      tagsValues = this.props.tags.filter((x) => {
        if (x.id !== Tag.Matchlist) {
          return x;
        }
      });
    } else {
      tagsValues = [...this.props.tags];
    }

    return (
      <div className="form-group">
        <label className="control-label col-sm-2">{fieldName}</label>
        <div className="col-sm-4">
          {(() => {
            if (fieldName === "type") {
              return (
                <select
                  id={id}
                  onChange={(e) => this.handleChange(e, Column.Value)}
                  value={this.getTypeValue(displayValue)}
                  className="form-control"
                >
                  {Types.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              );
            } else if (tag === Tag.Matchlist) {
              return (
                <div className="input-group">
                  <input
                    id={id}
                    class="form-control"
                    type="text"
                    data-toogle="tooltip"
                    title={fieldName}
                    disabled
                    onChange={(e) => this.handleChange(e, Column.Value)}
                    value={displayValue}
                  ></input>
                  <span class="input-group-btn">
                    <Button
                      className="btn btn-secondary"
                      id="btnfile"
                      onHide={this.closeMatchlistModal}
                      onClick={() =>
                        this.setState({ showMatchlistModal: true })
                      }
                      type="button"
                    >
                      Browse
                    </Button>
                  </span>
                  <MatchListModal
                    show={this.state.showMatchlistModal}
                    onHide={this.closeMatchlistModal}
                    onRowClick={this.onMatchListRowClick}
                    configurationName={this.props.configurationName}
                  />
                </div>
              );
            } else if (
              fieldName === "unit_family" ||
              fieldName === "unit_type" ||
              fieldName === "unit_version"
            ) {
              return (
                <input
                  id={id}
                  disabled={
                    this.state.configuration.readOnly || tag === Tag.Info
                  }
                  className="form-control"
                  type="text"
                  data-toogle="tooltip"
                  title={fieldName}
                  value={displayValue === '0' && tag == Tag.Info ? "" : displayValue}
                  onChange={(e) => this.handleChange(e, Column.Value)}
                />
              );
            } else if (dataType === DataType.String) {
              return (
                <input
                  id={id}
                  disabled={
                    this.state.configuration.readOnly || tag === Tag.Info
                  }
                  className="form-control"
                  type="text"
                  data-toogle="tooltip"
                  title={fieldName}
                  onChange={(e) => this.handleChange(e, Column.Value)}
                  value={value}
                />
              );
            } else if (dataType === DataType.Integer) {
              return (
                <input
                  id={id}
                  disabled={
                    this.state.configuration.readOnly || tag === Tag.Info
                  }
                  className="form-control"
                  type="number"
                  title={fieldName}
                  onChange={(e) => this.handleChange(e, Column.Value)}
                  value={value}
                />
              );
            } else if (dataType === DataType.Date) {
              return (
                <input
                  id={id}
                  disabled={
                    this.state.configuration.readOnly || tag === Tag.Info
                  }
                  className="form-control"
                  type="date"
                  title={fieldName}
                  onChange={(e) => this.handleChange(e, Column.Value)}
                  value={value}
                />
              );
            } else if (dataType === DataType.Boolean) {
              return (
                <input
                  id={id}
                  disabled={
                    this.state.configuration.readOnly || tag === Tag.Info
                  }
                  type="checkbox"
                  checked={JSON.parse(value)}
                  onChange={(e) => this.handleChange(e, Column.Value)}
                ></input>
              );
            }
          })()}
        </div>
        <div className="col-sm-6">
          <div className="col-sm-4">
            <select
              id={id}
              disabled={this.state.configuration.readOnly}
              className="form-control"
              value={tag}
              onChange={(e) => this.handleChange(e, Column.Tag)}
            >
              {tagsValues.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <input
            id={id}
            type="checkbox"
            style={{ margin: "5px" }}
            disabled={this.state.configuration.readOnly}
            checked={includeInRecipe}
            title="Include in Recipe"
            onChange={(e) => this.handleChange(e, Column.IncludeInRecipe)}
          />
          {(() => {
            if (
              !this.state.configuration.readOnly &&
              !this.state.configuration.isRequired
            ) {
              return (
                <a
                  onClick={() => {
                    this.onRemove(id, path);
                  }}
                >
                  <span
                    id={id}
                    class="glyphicon glyphicon-trash"
                    title="Remove"
                  />
                </a>
              );
            }
          })()}
          {(() => {
            if (this.props.displayAddButton) {
              return (
                <div>
                  <button
                    className="btn btn-sm btn-grey"
                    id="btnAddConfiguration"
                    onClick={() => this.setState({ showAddElementModal: true })}
                    type="button"
                  >
                    <Glyphicon glyph="plus" /> Add Field
                  </button>

                  <AddConfigurationElementModal
                    sequence={sequence}
                    parentId={this.props.configuration.parentId}
                    configurations={this.props.configurations}
                    path={path}
                    show={this.state.showAddElementModal}
                    onHide={this.closeAddElementModal}
                    onAdd={this.onAddField}
                    onRowClick={this.onAddField}
                  />
                </div>
              );
            }
          })()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    tags: state.configuration.elementProperties.tags,
  };
};

export default connect(mapStateToProps)(ConfigurationElement);
